"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _format = require('web/screens/Broadcast/format');

/* Rev 30 Z2: why the gate refuses an Add straight to a started campaign, in
 * the dialog that made it. Only variables with no default are ever missing. */
 const gateRefusalText = (gate) => {
  const missing = gate.MissingVariables[0]
  if (missing) {
    return `${_format.pluralize.call(void 0, missing.Count, 'row has', 'rows have')} no ${missing.Name}, and the message gives it no default.`
  }
  return `${_format.pluralize.call(void 0, gate.TooLongCount, "new recipient's message is", "new recipients' messages are")} over the ${_format.formatCount.call(void 0, gate.Limit)}-character limit.`
}; exports.gateRefusalText = gateRefusalText
